import type { State } from '../../typings'
import type { ActivityType } from '../../../typings'

export const openActivityTypeFormProducer = (
  state: State,
  payload?: ActivityType,
) => ({
  ...state,
  isOpen: true,
  current: payload,
})
